// extracted by mini-css-extract-plugin
export default {"title":"Subscribe_title__JEXsG","body":"Subscribe_body__BwPBB"};